<template>
  <div />
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import proxy from '../proxy/proxy'
import { spEsri } from '../globals'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

export default {
  name: 'Redirect',
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('/home')) {
      this.$store.dispatch('unSetActiveTool')
    }
    next()
  },
  data () {
    return {
      production: parseInt(process.env.VUE_APP_PRODUCTION),
    }
  },
  computed: {
    viewerName () {
      return this.$route.params.viewerName
    },
    type () {
      return this.$route.params.type
    },
  },
  async created () {
    this.$store.dispatch('setLayersLoaded', false)
    const body = {
      name: this.viewerName,
    }
    try {
      const response = await axios.post('/basicInfo', body)
      if (response.data.success === false) {
        this.$router.push('/error')
        this.$store.dispatch('setErrorMessage', '404 - Viewer does not exist.')
        return
      }
      if (response.data.active === false) {
        this.$router.push('/error')
        this.$store.dispatch('setErrorMessage', '404 - Viewer is not active.')
        return
      }
      const basicInfo = {
        viewerId: response.data.id,
        viewerName: response.data.name,
        organisationId: response.data.organisationfk,
        hasLogin: response.data.haslogin,
        ...(response.data.portalUrl && { organisationPortalUrl: response.data.portalUrl }),
        loginMethods: response.data.loginmethods,
        license: response.data.license,
      }
      this.$store.dispatch('setGeneralInfo', basicInfo)
      this.initStore(basicInfo.viewerName)
    } catch (error) {
      console.error(error)
      this.$router.push('error')
    }
  },

  methods: {
    async initStore (viewerName) {
      this.$store.dispatch('resetVuex')
      this.$store.dispatch('removeViews')
      this.loadLoggedInUserFromLocalStorage(viewerName)
      this.loadLanguageFromLocalStorage(viewerName)
      this.loadHighlightColorsDataFromLocalStorage(viewerName)
      this.loadFilterDataFromLocalStorage(viewerName)
      this.loadLabelingDataFromLocalStorage(viewerName)
      this.loadSymbologyDataFromLocalStorage(viewerName)
    },
    resetCustomConfiguration () {
      const configJson = this.$store.getters.getConfigJson
      // destroy html elements created in external js files
      if (configJson.appConfig.externalJs?.length > 0) {
      /* eslint-disable */  
        destroyElements(spEsri, this)
      /* eslint-enable */
      }
      // call client action destroy
      const widgets = this.$store.getters.getConfigJson.widgets
      const clientActionWidget = widgets.find(element => element.id === 'clientAction')
      if (clientActionWidget?.configured) {
        /* eslint-disable */  
          clientActionDestroyElements()
        /* eslint-enable */
      }
    },
    async getConfigJson (body) {
      try {
        const response = await axios.post('configPortal', body)
        if (response.data.success === true) {
          const configJson = response.data.configJson
          this.$store.dispatch('setConfigJson', configJson)
          if (this.$store.getters.getLanguage === null || this.$store.getters.getLanguage === '') {
            const language = configJson.appConfig.localization ? configJson.appConfig.localization[0].id : 'en'
            const data = {
              language: language,
              viewer: this.$store.getters.getViewerName,
              host: window.location.host,
            }
            this.$store.dispatch('setLanguage', data)
          }
          if (configJson.colorSchema) {
            const colorSchema = configJson.colorSchema
            Object.keys(colorSchema).forEach(i => {
              this.$vuetify.theme.themes.dark[i] = colorSchema[i]
              this.$vuetify.theme.themes.light[i] = colorSchema[i]
            })
          }
          // client actions
          const widgets = this.$store.getters.getConfigJson.widgets
          const clientActionWidget = widgets.find(element => element.id === 'clientAction')
          if (clientActionWidget?.configured) {
            const script = document.createElement('script')
            const clientActionWidgetConfiguration = this.$store.getters.getConfigJson.widgetConfig.clientAction
            if (clientActionWidgetConfiguration?.filePath) {
              const clientActionUrl = clientActionWidgetConfiguration.filePath
              script.setAttribute('src', clientActionUrl)
              script.type = 'text/javascript'
              document.head.appendChild(script)
            }
          }
          // custom tools
          this.registerCustomTools()

          if (configJson.customTools && configJson.appConfig?.logo) {
            const favicon = document.getElementById('favicon')
            favicon.href = configJson.appConfig.logo
          }
          if (configJson.appConfig?.tablogo) {
            const favicon = document.getElementById('favicon')
            favicon.href = configJson.appConfig.tablogo
          }
          if (configJson.appConfig?.queryDistance) {
            this.$store.dispatch('setQueryDistance', configJson.appConfig.queryDistance)
          }
          if (configJson.appConfig?.defaultHighlightColor) {
            this.$store.dispatch('setDefaultHighlightColor', configJson.appConfig.defaultHighlightColor)
          }
          if (configJson.appConfig?.defaultHighlightLineWidth) {
            this.$store.dispatch('setDefaultHighlightLineWidth', configJson.appConfig.defaultHighlightLineWidth)
          }
          if (configJson.appConfig?.defaultHighlightPolygonOutlineWidth) {
            this.$store.dispatch('setDefaultHighlightPolygonOutlineWidth', configJson.appConfig.defaultHighlightPolygonOutlineWidth)
          }
          if (configJson.appConfig?.defaultHighlightPolygonFillStyle) {
            this.$store.dispatch('setDefaultHighlightPolygonFillStyle', configJson.appConfig.defaultHighlightPolygonFillStyle)
          }
          if (configJson.appConfig?.localization ? !!configJson.appConfig.localization[0].disclaimer : false) {
            this.$store.dispatch('setHasDisclaimer', true)
          } else {
            this.$store.dispatch('setHasDisclaimer', false)
          }

          const loggedInUser = this.$store.getters.getLoggedInUser
          if (this.$store.getters.getHasLogin === 0) {
            this.initPublicMode()
            proxy('token', configJson)
          } else if (loggedInUser == null && this.$store.getters.getHasLogin === 2) {
            this.initMixedMode()
          } else {
            let type = null
            if (loggedInUser) {
              const token = this.$store.getters.getAccessToken
              if (token) {
                proxy(token, configJson)
              }
            }
            let path = '/' + this.$store.getters.getViewerName
            if (this.type === 'home') {
              type = 'home'
              path += '/home'
            } else {
              type = 'login'
              path += '/login'
            }
            document.title = this.$store.getters.getConfigJson.appConfig?.tabTitle ? this.$store.getters.getConfigJson.appConfig.tabTitle : (this.$store.getters.getViewerName ? this.$store.getters.getViewerName : 'Smart Viewer')
            this.$router.push(path)
            this.initExternalFile(type)
          }
        } else {
          const basic = {
            viewerId: null,
            viewerName: null,
            organisationId: null,
            hasLogin: null,
          }
          this.$store.dispatch('setGeneralInfo', basic)
          if (response.data.message.startsWith('File not found')) {
            this.$store.dispatch('setErrorMessage', 'Not found config.json.')
          } else {
            this.$store.dispatch('setErrorMessage', 'Wrong config.json format.')
          }
          if (this.production) {
            window.location = '/smartViewer/#/error'
          } else {
            window.location = '/#/error'
            this.$router.push('error')
          }
        }
      } catch (error) {
        window.location = '/#/error'
        console.error(error)
      }
    },
    async initMixedMode () {
      let type = null
      const input = {
        viewerfk: this.$store.getters.getViewerId,
        organisationfk: this.$store.getters.getOrganisationId,
      }
      try {
        const response = await axios.post('mixedAuth', input)
        const mixedInfo = response.data
        this.$store.dispatch('doMixedAuth', mixedInfo)
        proxy(this.$store.getters.getAccessToken, this.$store.getters.getConfigJson)
        let path = '/' + this.$store.getters.getViewerName
        if (this.type === 'home') {
          path += '/home'
          type = 'home'
        } else {
          path += '/login'
          type = 'login'
        }
        document.title = this.$store.getters.getConfigJson.appConfig?.tabTitle ? this.$store.getters.getConfigJson.appConfig.tabTitle : (this.$store.getters.getViewerName ? this.$store.getters.getViewerName : 'Smart Viewer')
        this.$router.push(path)
        this.initExternalFile(type)
      } catch (error) {
        console.error(error)
        this.$router.push('error')
      }
    },
    async initPublicMode () {
      let type = null
      const input = {
        viewer: this.$store.getters.getViewerName,
      }
      try {
        const response = await axios.post('publicToken', input)
        this.$store.dispatch('doMixedAuth', response.data)
        proxy(this.$store.getters.getAccessToken, this.$store.getters.getConfigJson)
        let path = '/' + this.$store.getters.getViewerName
        if (this.type === 'home') {
          path += '/home'
          type = 'home'
        } else {
          path += '/login'
          type = 'login'
        }
        this.$router.push(path)
        this.initExternalFile(type)
      } catch (error) {
        this.$router.push('error')
        console.error(error)
      }
    },
    async loadLoggedInUserFromLocalStorage (viewerName) {
      if (this.$store.getters.getHasLogin !== 0 && localStorage.getItem(window.location.host + '-' + viewerName + '-loggedInUser')) {
        const localStorageViewerData = JSON.parse(localStorage.getItem(window.location.host + '-' + viewerName + '-loggedInUser'))
        const userObject = {
          loggedInUser: localStorageViewerData.loggedInUser,
          token: localStorageViewerData.token,
          refreshToken: localStorageViewerData.refreshToken,
        }
        this.$store.dispatch('doLogin', userObject)
        try {
          const response = await axios.get('userDetails',
            {
              headers: {
                Authorization: 'Bearer ' + localStorageViewerData.token,
              },
            })

          const userObject2 = {
            loggedInUser: this.$store.getters.getLoggedInUser,
            token: this.$store.getters.getAccessToken,
            refreshToken: this.$store.getters.getRefreshToken,
            roles: response.data.roles,
            attachmentPrivileges: response.data.attachmentPrivileges,
            queryDefs: response.data.queryDefs,
            forbiddenWidgets: response.data.forbiddenWidgets,
            extents: response.data.extents,
          }
          this.$store.dispatch('doLogin', userObject2)
          const body = {
            viewer: viewerName,
            type: 'get',
          }
          this.getConfigJson(body)
        } catch (error) {
          console.error(error)
        }
      } else {
        const body = {
          viewer: viewerName,
          type: 'get',
        }
        this.getConfigJson(body)
      }
    },
    loadLanguageFromLocalStorage (viewerName) {
      if (localStorage.getItem(window.location.host + '-' + viewerName + '-language')) {
        const localStorageViewerData = JSON.parse(localStorage.getItem(window.location.host + '-' + viewerName + '-language'))
        const data = {
          language: localStorageViewerData.language,
          viewer: viewerName,
          host: window.location.host,
        }
        this.$store.dispatch('setLanguage', data)
      }
    },
    loadHighlightColorsDataFromLocalStorage (viewerName) {
      let savedHighlightColors = null

      if (localStorage.getItem(window.location.host + '-' + viewerName + '-highlightColors')) {
        savedHighlightColors = localStorage.getItem(window.location.host + '-' + viewerName + '-highlightColors')
      }
      if (savedHighlightColors) {
        this.$store.dispatch('setHighlightColorsFromLocalStorage', savedHighlightColors)
      }
    },

    loadFilterDataFromLocalStorage (viewerName) {
      let savedFilters = null
      if (localStorage.getItem(`filters-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))) {
        savedFilters = localStorage.getItem(`filters-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))
      }
      if (savedFilters) {
        this.$store.dispatch('loadFiltersFromLocalStorage', savedFilters)
      }
    },

    loadLabelingDataFromLocalStorage (viewerName) {
      let savedLabeling = null
      if (localStorage.getItem(`labeling-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))) {
        savedLabeling = localStorage.getItem(`labeling-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))
      }
      if (savedLabeling) {
        this.$store.dispatch('loadLabelingFromLocalStorage', savedLabeling)
      }
    },
    loadSymbologyDataFromLocalStorage (viewerName) {
      let savedSymbology = null
      if (localStorage.getItem(`symbology-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))) {
        savedSymbology = localStorage.getItem(`symbology-${viewerName}` + (this.$store.getters.getLoggedInUser?.username ? `-${this.$store.getters.getLoggedInUser.username}` : ''))
      }
      if (savedSymbology) {
        this.$store.dispatch('loadSymbologyFromLocalStorage', savedSymbology)
      }
    },

    initExternalFile (type) {
      const elementsCss = document.getElementsByClassName('customCss')
      const i = 0
      while (elementsCss.length > i) {
        elementsCss[0].parentNode.removeChild(elementsCss[0])
      }
      const elementsJs = document.getElementsByClassName('customJs')
      const j = 0
      while (elementsJs.length > j) {
        elementsJs[0].parentNode.removeChild(elementsJs[0])
      }

      const config = this.$store.getters.getConfigJson
      if (config.appConfig.externalCss?.length > 0) {
        const head = document.getElementsByTagName('head')[0]
        for (const address of config.appConfig.externalCss) {
          const link = document.createElement('link')
          link.rel = 'stylesheet'
          link.type = 'text/css'
          link.className = 'customCss'
          link.href = address
          link.media = 'all'
          head.appendChild(link)
        }
      }
      if (config.appConfig.externalJs?.length > 0) {
        const head = document.getElementsByTagName('head')[0]
        for (const address of config.appConfig.externalJs) {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.className = 'customJs'
          script.src = address
          head.appendChild(script)
        }
      }
      if (config.appConfig?.startUpFunction) {
        this.$router.push('/startup/' + this.$store.getters.getViewerName + '/' + type)
      }
    },
    registerCustomTools () {
      const configJson = this.$store.getters.getConfigJson
      if (!configJson) {
        return
      }
      if (!configJson.customTools) {
        return
      }
      const requireComponent = require.context(
        // The relative path of the custom tools folder
        '../customTools',
        // Whether or not to look in subfolders
        true,
        // The regular expression used to match custom tool filenames
        /[A-Z]\w+\.(vue)$/
      )
      requireComponent.keys().forEach(fileName => {
        // Get component config
        const componentConfig = requireComponent(fileName)
        // Get PascalCase name of component
        const componentName = upperFirst(
          camelCase(
            // Gets the file name regardless of folder depth
            fileName
              .split('/')
              .pop()
              .replace(/\.\w+$/, '')
          )
        )
        // Register component globally
        Vue.component(
          componentName,
          // Look for the component options on `.default`, which will
          // exist if the component was exported with `export default`,
          // otherwise fall back to module's root.
          componentConfig.default || componentConfig
        )
      })
    },
  },
}
</script>
